import { Icon } from '@/lib/icons';
import { usePhone } from './PhoneProvider';

/* A phone number as it appears on an account: a click-to-call through the
   softphone when browser calling is configured, otherwise the plain tel: link
   it always was (the phone plan's rule: optional integrations degrade). */
export function CallButton({ to, label, name, className = '' }: { to: string; label?: string; name?: string; className?: string }) {
  const p = usePhone();
  const text = label ?? to;
  if (!p.enabled || p.state === 'off') return <a className={className} href={`tel:${to}`}><Icon name="phone" size={14} /> {text}</a>;
  const busy = p.state !== 'idle';
  return (
    <button type="button" className={`sp-call ${className}`} disabled={busy} title={busy ? 'Already on a call' : `Call ${name ?? to} from clientIQ`}
      onClick={() => void p.dial(to, name)}>
      <Icon name="phone" size={14} /> {text}
    </button>
  );
}
